import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
// import VideoPlayer from "../../../../components/player";
import {Button, Card, Col, Row, Space} from "antd";
import ChartImage1 from '../../../../assets/img/tenant1.png'
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '0px'}}>
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 2}} span={AuthLayout}>
                            
                        </Col>  
                        <Col lg={{span: 20}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        position: 'center',
                                        paddingTop: '0%',
                                    }}>
                                    {/* <VideoPlayer url='https://www.youtube.com/watch?v=5diKT47hJAg'/> */}
                                    
                                </div>
                            </Space>
                        </Col>
                        <Col lg={{span: 2}} span={AuthLayout}>
                            
                        </Col>
                    </Row>
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 2}} span={AuthLayout}>
                            
                        </Col>
                        <Col lg={{span: 4}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        position: 'relative',
                                        paddingTop: '0%',
                                    }}>
                                    <img src={ChartImage1} alt=""/>
                                    
                                </div>
                            </Space>
                        </Col>
                        <Col lg={{span: 16}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        position: 'relative',
                                        paddingTop: '0%',
                                    }}>
                                    {/* Setup your ID once and use it over and over when applying for rentals.<br/><br/> */}
                                    {/* No more filling out the same information over and over again. */}

<b>Identity Verification and Protection</b> is a critical component of modern business operations, offering a wide range of benefits that enhance security, compliance and efficiency. It offers numerous benefits such as:<br/><br/>

<b>1. Saves Time</b><br/>
Automates the verification process, reducing the need for manually enter personal details over and over.
<br/><br/>
<b>2. Fraud Prevention</b><br/>
Verifying identities helps prevent fraudulent activities such as identity theft, account takeovers, and unauthorized access.
<br/><br/>
<b>3. Enhanced Security</b><br/>
Ensures that sensitive information is only accessible to verified individuals, reducing the risk of data breaches.
<br/><br/>
<b>4. Monitoring and Alerts</b><br/>
Continuous monitoring of verified identities can help in detecting suspicious activities early.
<br/><br/>
<b>5. Access Control</b><br/>
Provides one click access to services, enhancing overall security and a record of identity verification activities.
<br/><br/>
                                </div>
                            </Space>
                        </Col>
                        <Col lg={{span: 2}} span={AuthLayout}>
                            
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`
export default AboutMain;
